<template>
  <router-link :to="url" class="nav-link" v-bind="$attrs">
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
      :style="isCategory ? 'display: none!important;' : ''"
    >
      <slot name="icon"></slot>
    </div>
    <span
      class="nav-link-text"
      :class="'ms-1'"
      :style="isCategory ? 'font-weight: 600!important; color: black;' : ''"
      >{{ navText }}</span
    >
    <!-- 메뉴 이름 뒤 표시(예: 대기 건수 배지) -->
    <slot />
  </router-link>
</template>
<script>
export default {
  name: "sidenav-item",
  props: {
    url: {
      type: String,
      required: true,
    },
    navText: {
      type: String,
      required: true,
    },
    isCategory: {
      type: Boolean,
      required: false,
    },
  },
};
</script>
